@use "foundation/colors";
@use "foundation/responsive";

.payment-info-form {
  margin: 0 auto;

  @include responsive.phone {
    width: 100%;
  }

  // Reserve vertical space before Stripe.js + Elements mount so the CTA does not jump (CLS).
  .payment-element-slot {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    // Cap avoids huge empty belts under the Payment Element on tall desktops when the iframe is shorter than `vh`.
    // Slightly taller reserve vs typical tabs + card + expiry/CVC rows to reduce vertical gap when Stripe mounts.
    min-height: clamp(240px, 26vh, 320px);
  }

  // Keeps Stripe’s iframe intrinsic min-content from widening the checkout column when Elements mounts.
  .stripe-mount {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;

    :global(.StripeElement) {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }

    // Stripe wraps iframes in layered divs — cap width without touching iframe internals.
    & > :global(div) {
      max-width: 100%;
      box-sizing: border-box;
    }
  }

  .payment-element-placeholder {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
  }

  .skeleton-tab-row {
    display: flex;
    gap: 8px;
    width: 58%;
  }

  .skeleton-tab {
    flex: 1;
    min-height: 44px;
    border-radius: 8px;
    background-color: rgb(34 34 34 / 8%);
  }

  .skeleton-field {
    width: 100%;
    min-height: 52px;
    border-radius: 8px;
    background-color: rgb(34 34 34 / 8%);
  }

  .skeleton-split-row {
    display: flex;
    gap: 8px;
    width: 100%;
  }

  .skeleton-field-half {
    flex: 1;
    min-height: 52px;
    border-radius: 8px;
    background-color: rgb(34 34 34 / 8%);
  }

  .action-buttons {
    text-align: center;
    // Replaces global `mt4` (32px); roomy layouts don’t need that much air above the primary CTA.
    margin-top: 12px;

    // Keep CTA clear of fixed support widgets near the viewport bottom.
    @include responsive.phone {
      margin-top: 24px;
      margin-bottom: calc(96px + env(safe-area-inset-bottom));
    }
  }

  .status-copy {
    color: colors.$neutrals-dark-grey;
    font-size: 14px;
    font-weight: 600;
    margin-top: 12px;
    text-align: center;
  }

  .intent-error {
    color: colors.$neutrals-dark-grey;
    font-size: 14px;
    margin-top: 12px;
    text-align: center;

    p {
      margin-bottom: 8px;
    }
  }
}
